import { SiteLogo } from '../ui/SiteLogo';
import { AuroraBackground } from '../ui/AuroraBackground';
import './GlobalLoader.css';

/**
 * Écran de chargement affiché pendant que les paramètres du site et l'état de
 * connexion se chargent (PublicLayout). Reprend l'identité visuelle de la page
 * de maintenance (aurore + anneau qui pulse) en version claire/légère.
 */
export function GlobalLoader() {
  return (
    <div className="global-loader">
      <AuroraBackground tone="light" />

      <div className="global-loader__content">
        <div className="global-loader__logo-wrap">
          <span className="global-loader__ring" />
          <span className="global-loader__ring global-loader__ring--delay" />
          <SiteLogo tone="clair" height={56} />
        </div>

        <div className="global-loader__dots" aria-hidden="true">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
}
